import React from 'react';
import { ClipboardCheckIcon, FileTextIcon, MapIcon, RulerIcon, TriangleAlertIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { extras } from '../data/content';
const icons = {
  map: MapIcon,
  checklist: ClipboardCheckIcon,
  ruler: RulerIcon,
  alert: TriangleAlertIcon,
  worksheet: FileTextIcon
};
export function Extras() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="extras-title" data-id="element-114" data-mp="tov9djwhv0ll">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-115" data-mp="tqyap033kg5m">
        <h2 id="extras-title" className="text-center font-serif text-[32px] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-116" data-mp="yozr1d9521de">
          And you’ll <em className="text-brand-600" data-id="element-117" data-mp="kq9v40y227qm">also</em> receive
        </h2>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-118" data-mp="oqk0pchxqw4y">
          {extras.map(e => {
          const Icon = icons[e.icon];
          return <li key={e.title} className="flex gap-4" data-id="element-119" data-mp="2j430yu3costy">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-brand-100 text-brand-700" data-id="element-120" data-mp="2j1gwj3bratfy">
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-121" data-mp="vbfo545i66kt" />
                </span>
                <div data-id="element-122" data-mp="19ziuiengjka5">
                  <h3 className="text-lg font-extrabold text-ink" data-id="element-123" data-mp="1a0214z7nqm8v">{e.title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-muted" data-id="element-124" data-mp="150z2pxm6ne9v">{e.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-3xl rounded-3xl bg-brand-50 px-6 py-8 text-center" data-id="element-125" data-mp="hd7j08ybbyyk">
          <p className="font-serif text-2xl font-extrabold text-brand-800 sm:text-3xl" data-id="element-126" data-mp="ce4ovjjvfd5d">
            Any implant case that requires CBCT review…
          </p>
          <p className="mt-3 text-[17px] leading-relaxed text-ink" data-id="element-127" data-mp="m96bo8qoc34s">
            You’ll have a structured reference to help you move through the scan step by step instead of relying
            entirely on memory or intuition.
          </p>
        </div>

        <CtaButton className="mt-12" label="I want the complete CBCT Decision Map™" data-id="element-128" data-mp="1xrphin7ameww" />
      </div>
    </section>;
}